import { ChevronRightIcon, Flex } from "@shared/primitive-components"
import { tableCellStyles as styles } from "../../../styles"

type Props = {
  dataTestId?: string
}

export const ChevronFakeLinkCell = ({ dataTestId }: Props) => (
  <Flex alignItems="center" css={styles.chevronLinkStyle} data-testid={dataTestId}>
    <ChevronRightIcon />
  </Flex>
)

ChevronFakeLinkCell.defaultProps = {
  dataTestId: undefined,
}
